<template>
    <article>

        <!-- 年卡费用 -->
        <div class="white_bg marginT8" style="padding-bottom: 12px"
             v-show="!userInstance || !userInstance.isVipType('course_vod')">
            <div class="generalPagePaddingH">
                 <div class="wFit center paddingT16">
                     <div class="relative">
                         <img class="limit_max_width" src="vip/vip_course_year_price.png" width="339" height="auto"/>
                         <div class="alignC coffeeColor" style="font-size: 20px; position: absolute;
                            top: 35px; width: 100%; left: 0">
                             ￥{{vipPrice}}/年
                         </div>
                         <div class="alignC marginT8 textDelete f16" style="color: #B8C2D6; position: absolute;
                            top: 58px; width: 100%; left: 0">
                             ¥{{originalPrice}}
                         </div>
                     </div>
                     <div class="font13r">
                         <label>
                             <input class="modernCheckbox orangeCircleTickCheckbox" type="checkbox" :checked="agreeServiceProtocol"
                                    @change="changeAgreeServiceProtocol"/>
                             <span style="color: hsla(219, 9%, 39%, 1)">开通即同意</span>
                             <a style="color: hsla(2, 100%, 70%, 1);" :href="externalApp.oldShixun.baseUrl + 'html/txt.html?VIP=VIP'">
                                 《师讯VIP会员服务协议》
                             </a>
                         </label>
                     </div>
                 </div>
            </div>
        </div>

        <div class="white_bg marginT8 paddingH8" style="padding-top: 4px;">
            <article class="article" v-if="details.length">
                <img v-if="details[0].cover" :src="details[0].cover"/>
            </article>
        </div>

        <customerServiceQrDrawer ref="customerServiceQrDrawer" :qrUrl="customerServiceQrDrawer.qrUrl"/>
        <downloadToEmailDrawer ref="downloadToEmailDrawer" @submit="downloadToEmail"/>

    </article>
</template>

<script>

import introductionPart from './introductionPart';

// style
import './indroduction.scss';

// data
import externalApp from '@data/externalApp';
import vipTypeEnum2 from '@data/vipTypeEnum2';
let vipType = vipTypeEnum2.COURSE_VOD;

// modules
import bannerModule from '@comp/bannerModule';
import customerServiceQrDrawer from '@comp/drawer/customerServiceQrDrawer'
import downloadToEmailDrawer from '@pages/vip/downloadToEmailDrawer';

export default {
    extends : introductionPart,
    components: { bannerModule, customerServiceQrDrawer, downloadToEmailDrawer },
    props : {
        vipPrice : String,
        originalPrice : String,
        details : Array,
    },
    data() {
        return {
            vipType : vipType,
            externalApp : externalApp
        }
    }
}
</script>

<style lang="scss" scoped>

.coffeeColor {
    color: #846130;
}

.vip_title_icon{
    display: inline-block;
    width: 45px;
    height: 13px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url(data:image/png;base64,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);
}

</style>
